'use strict'
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./rtk-query-react.production.min.cjs')
} else {
  module.exports = require('./rtk-query-react.development.cjs')
}